var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "inline-block" } }, [
    _vm.buttonsize === undefined
      ? _c(
          "button",
          {
            staticClass: "btn btn-sm btn-primary no-border ",
            staticStyle: { border: "none" },
            on: { click: _vm.follow },
          },
          [
            _vm.following === false
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.join")) + " "),
                  _c("i", { staticClass: "feather icon-user-plus" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === true
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.leave")) + " "),
                  _c("i", { staticClass: "feather icon-log-out" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === "pending"
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.requested")) + " "),
                  _c("i", { staticClass: "feather icon-log-in" }),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.buttonsize === "large"
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary no-border",
            staticStyle: { border: "none" },
            on: { click: _vm.follow },
          },
          [
            _vm.following === false
              ? _c("div", [
                  _vm._v(_vm._s(_vm.__("globals.join")) + " "),
                  _c("i", { staticClass: "feather icon-user-plus" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === true
              ? _c("div", [
                  _vm._v(_vm._s(_vm.__("globals.leave")) + " "),
                  _c("i", { staticClass: "feather icon-log-out" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === "pending"
              ? _c("div", [
                  _vm._v(_vm._s(_vm.__("globals.requested")) + " "),
                  _c("i", { staticClass: "feather icon-log-in" }),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "leave_response_" + this.group.id,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "leaveQuestionTitle",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "exampleModalLongTitle" },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.before_you_leave")))]
                ),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("p", { staticClass: "text-left" }, [
                  _vm._v(_vm._s(this.group.leave_question_text)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("textarea", {
                    staticClass: "form-control",
                    attrs: {
                      name: "response",
                      id: "response_" + this.group.id,
                      cols: "30",
                      rows: "5",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "text-success text-left",
                  attrs: { id: "thankyou_" + this.group.id },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ml-auto",
                    attrs: { id: "buttons_" + this.group.id },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sml btn-danger",
                        attrs: { id: "skip" },
                        on: { click: _vm.closeModal },
                      },
                      [_vm._v("Skip")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sml btn-success ml-05",
                        attrs: { id: "submit_response" },
                        on: { click: _vm.storeResponse },
                      },
                      [_vm._v(_vm._s(_vm.__("globals.submit_response")))]
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }